import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const chooserStyle = {
  container: (styles: Record<string, any>) => ({ ...styles, maxWidth: 600 }),
  option: (
    base: Record<string, any>,
    { isSelected }: { isSelected: boolean }
  ) => ({
    ...base,
    backgroundColor: isSelected
      ? token('color.background.neutral.subtle.pressed', colors.N500)
      : token('color.background.input', colors.N0),
    '&:hover': {
      backgroundColor: isSelected
        ? token('color.background.neutral.subtle.pressed', colors.N500)
        : token('color.background.neutral.subtle.hovered', colors.N30),
    },
  }),
};
